
export function formatDateForSignature(input: string): string {
  const date = new Date(input);

  const pad = (n: number) => n.toString().padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  const offsetMin = -date.getTimezoneOffset();
  const sign = offsetMin >= 0 ? '+' : '-';
  const offsetHours = pad(Math.floor(Math.abs(offsetMin) / 60));
  const offsetMinutes = pad(Math.abs(offsetMin) % 60);

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${sign}${offsetHours}:${offsetMinutes}`;
}
